import { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
} from '@material-ui/core';

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

import * as Yup from 'yup';
import { Formik } from 'formik';

import { getCurrentUser } from "../../utils/auth"
import APIS from "../../utils/APIS"

export const passwordValidation = {
  required: "Veuillez entrer un mot de passe",
  regex: /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[ !"#$%&'()*,-.:\;<>?@[\]^_`{|}~])/,
  matches:
    "Doit contenir au moins 8 caractères, 1 majuscule, 1 minuscule, 1 chiffre et un caractère spécial",
  majMinRegex: /(?=.*[a-z])(?=.*[A-Z])/,
  majMinMatches: "Doit contenir au moins 1 majuscule et 1 minuscule",
  digitSpecialCharRegex: /(?=.*\d)(?=.*[ !"#$%&'()*,-.:\;<>?@[\]^_`{|}~])/,
  digitSpecialCharMatches:
    "Doit contenir au moins 1 chiffre et un caractère spécial (les symboles + et = ne sont pas valides)",
  min: "Doit contenir au moins 8 caractères",
}

const SettingsPassword = (props) => {

  const currentUser = getCurrentUser()

  const [passwdChangedMessage, setPasswdChangedMessage] = useState("")

  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  return (
    <Card>
      <CardHeader
        subheader=""
        title="Modifier votre mot de passe"
      />
      <Divider />
        <Formik
          initialValues={{
            password: '',
            confirm : '',
          }}
          validationSchema={Yup.object().shape({
            password: Yup.string()
              .min(8, passwordValidation.min)
              .matches(passwordValidation.regex, passwordValidation.matches)
              .required(passwordValidation.required),
            confirm: Yup.string()
              .oneOf([Yup.ref('password'), null], 'Les mots de passe doivent correspondre')
          })}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            APIS.changePassword({
              password: values.password,
              confirm : values.confirm,
            }).then(result => {
              if (result.message == "changePassword") {
                resetForm({})
                setPasswdChangedMessage("Mot de passe modifié !")
                setTimeout(function(){
                  setSubmitting(false);
                  setPasswdChangedMessage("")
                }, 4000);
              } else {
                resetForm({})
                setSubmitting(false);
                alert("Une erreur est survenue")
              }
            })
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            touched,
            values
          }) => (
            <form onSubmit={handleSubmit}>
              <CardContent>
                <TextField
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label="Mot de passe"
                  margin="normal"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  required
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.password}
                  inputProps={{ maxLength: 70 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
                <TextField
                  error={Boolean(touched.confirm && errors.confirm)}
                  fullWidth
                  helperText={touched.confirm && errors.confirm}
                  label="Confirmation"
                  margin="normal"
                  name="confirm"
                  type={showPassword ? "text" : "password"}
                  variant="outlined"
                  required
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.confirm}
                  inputProps={{ maxLength: 70 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
                </CardContent>
                <Divider />
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems : 'center',
                    p: 2
                  }}
                >
                  <Typography style={{color:'green'}}>
                    {passwdChangedMessage}
                  </Typography>
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={isSubmitting}
                    type="submit"
                  >
                    MODIFIER
                  </Button>
                </Box>
              </form>
          )}
        </Formik>
    </Card>
  );
};

export default SettingsPassword;
